export const instagramInitialState = {
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: '',
    platform: 'news',
    hasPlatformAsParent: true,
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    hasIncludeExclude: false,
    filterType: 'include',
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    platform: 'news',
    hasPlatformAsParent: true,
    hasIncludeExclude: true,
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
  },
  advertFilter: {
    hasFilter: false,
    isOpen: false,
    selectedObjectValues: {
      min: 0,
      max: 1,
      active: false,
    },
    componentName: 'advertFilter',
    translateKey: 'filter:advertLevel',
  },
};
